// Fallback content — mirrors the backend seed so the page never renders empty
// if the API is unreachable. Live data always overrides this.

const U = "https://images.unsplash.com/";
const Q = "?crop=entropy&cs=srgb&fm=jpg&q=85";
const REAL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_artwork-showcase-11/artifacts/9l77ybos_utuytu.jpeg";

export const GALLERY_FALLBACK = {
  exhibition: "Quiet Hours",
  artist_name: "Warren Wulkan",
  artist_email: "info@wwabstract.com",
  location: "Punta Gorda, FL · Central Maine · Buffalo, NY",
  hero_overline: "Warren Wulkan · Selected Works",
  hero_tagline: "Contemporary Abstract Art",
  hero_image: REAL,
  statement:
    "Paintings alive with color, texture, and depth—drawing you in to discover more.",
  marquee_text: "Quiet Hours — Selected Works — Warren Wulkan",
  chapters: [
    {
      number: "01",
      title: "On Slowness",
      body:
        "Please take your time exploring the collection and discovering the unique details that give each painting its character. I welcome your questions and comments.",
      signoff: "Thank You, Warren!",
    },
    {
      number: "02",
      title: "On Looking",
      body:
        "Looking is not the same as seeing. A painting reveals itself the way a room warms — gradually, and only to those patient enough to remain inside it.",
    },
    {
      number: "03",
      title: "On Leaving",
      body:
        "You will carry one of these with you, even if only in memory. That is the quiet purpose of a picture — to keep a little of your stillness long after you have gone.",
    },
  ],
  about_headline: "About the Artist",
  about_image:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_artwork-showcase-11/artifacts/2k4vwfy0_WhatsApp%20Image%202026-08-29%20at%208.31.25%20PM.jpeg",
  about_body: [
    "Warren’s journey into art was unconventional. After spending more than 30 years building a career centered on leadership, problem-solving, and working with people, painting became a deeply personal source of calm, freedom, and creative expression. Working primarily with palette knives, he builds each composition through instinctive layers of color and texture, allowing imperfections, movement, and unexpected marks to become part of the finished work.",
    "In July 2026, Warren presented his work publicly for the first time in a highly successful solo exhibition. More meaningful than its success was witnessing people pause, move closer, and form an emotional connection with something he had created. That response strengthened his confidence and commitment to continue exploring and evolving as an artist.",
    "For Warren, the greatest reward is knowing that a painting created alone in his studio may become part of someone else’s daily life—bringing beauty, happiness, inspiration, or simply a moment of calm. His work invites viewers not only to see nature differently, but to experience something personal and lasting within it.",
  ],
  about_signature: "Warren Wulkan",
  about_title: "Contemporary Artist",
  about_footnote:
    "Selected works are on Display at Tesori 5688 MAIN STREET, WILLIAMSVILLE, NEW YORK — PLEASE STOP BY and view my work!",
  closing_title: "Take one home.",
  closing_body:
    "Each piece is an original, available as a single edition. If a work has kept your attention this long, perhaps it belongs with you. Write to the artist — he answers every letter himself.",
};

const P = [
  ["The Loud Hour", "2025", "Oil & acrylic impasto on canvas", "140 × 110 cm", "6,200",
    "Painted in a single uninterrupted afternoon — every colour arriving before there was time to choose it. The drips of turquoise and white are the argument the painting had with itself before it was allowed to be finished.",
    REAL, "Chaotic abstract expressionist painting in reds, greens, yellows and oranges with dripping impasto"],
  ["Crimson Meridian", "2024", "Oil & cold wax on linen", "120 × 90 cm", "4,800",
    "A study in heat and interruption — the red refuses to sit still, arguing with the blue beneath until neither is allowed to win.",
    U + "photo-1541961017774-22349e4a1262" + Q, "Textured red, yellow and blue abstract painting"],
  ["Horizon Withheld", "2023", "Pigment & acrylic on canvas", "140 × 100 cm", "5,200",
    "Two fields of muted earth meet at a line that never quite settles — a horizon you feel more than see.",
    U + "photo-1775313089045-82de47198832" + Q, "Colour field abstract landscape with muted earthy tones"],
  ["The Weight of Afternoon", "2024", "Oil impasto on board", "90 × 90 cm", "3,900",
    "Built up in thick strokes over many sittings, the surface holds the particular heaviness of a warm, idle afternoon.",
    U + "photo-1731652469577-9eebf01ea070" + Q, "Heavily textured impasto painting in orange and yellow"],
  ["Where the Mountains Rest", "2022", "Oil on canvas", "150 × 100 cm", "6,100",
    "Water, stone and trees held in a long silence — the kind of view that asks you to lower your voice.",
    U + "photo-1506744038136-46273834b3fb" + Q, "Atmospheric mountain landscape painting with water and trees"],
  ["First Light, Unnamed", "2023", "Acrylic on canvas", "110 × 110 cm", "4,400",
    "Colour arriving before form — the first minutes of a day, before anything has been decided.",
    U + "photo-1615184697985-c9bde1b07da7" + Q, "Blue, yellow and red abstract painting"],
  ["Meadow, Breathing", "2024", "Oil & pastel on canvas", "130 × 95 cm", "5,600",
    "Clouds hover low over a flowering field; stand long enough and the whole meadow seems to rise and fall.",
    U + "photo-1742294009985-a688e521f881" + Q, "Colour field painting with clouds over a flowering meadow"],
  ["A Thousand Small Hours", "2023", "Mixed media & impasto on panel", "100 × 100 cm", "4,700",
    "Every colour is a minute; together they are the slow accumulation of an ordinary, irreplaceable week.",
    U + "photo-1530017421197-2ca7a184d808" + Q, "Multicolour thick impasto abstract canvas"],
  ["Field Notes in Grey", "2022", "Charcoal & gesso on panel", "100 × 100 cm", "3,200",
    "Almost nothing, and yet not empty — read slowly, the greys begin to hold a faint, deliberate warmth.",
    U + "photo-1541512416146-3cf58d6b27cc" + Q, "Monochrome abstract canvas in soft greys"],
  ["The Quiet Lake", "2024", "Oil on canvas", "140 × 100 cm", "5,400",
    "A body of still water ringed by trees, painted at the hour when even the wind seems to be listening.",
    U + "photo-1688588426729-dc4f7bdb8fbe" + Q, "Serene painting of a body of water surrounded by trees"],
  ["Dusk Interior", "2023", "Acrylic & oil on canvas", "120 × 120 cm", "4,900",
    "Purple folding into orange — the warmth of a room just as the last daylight gives it up.",
    U + "photo-1775026880807-97d4d9585bf0" + Q, "Modern abstract painting with textured purple and orange hues"],
  ["Between Two Weathers", "2024", "Oil on linen", "160 × 110 cm", "6,800",
    "Mountains and fields caught between one weather and the next — the charged, held breath before change.",
    U + "photo-1774015583867-6834d9553faf" + Q, "Vibrant colour field landscape of mountains and fields"],
  ["Low Tide", "2023", "Acrylic & sand on canvas", "110 × 90 cm", "4,200",
    "Orange, white and teal pulled back like a receding sea, leaving the quiet evidence of where it had been.",
    U + "flagged/photo-1567934150921-7632371abb32" + Q, "Orange, white and teal abstract painting"],
  ["Ember Season", "2024", "Oil impasto on canvas", "120 × 100 cm", "5,100",
    "The last warmth of the year worked thickly into the surface, still glowing under the blue that follows.",
    U + "photo-1524664399170-77e7118fdb6d" + Q, "Vibrant orange, red and blue textured abstract painting"],
  ["Someone I Almost Knew", "2023", "Oil on canvas", "90 × 70 cm", "3,800",
    "A face assembled from memory and colour — familiar the way a half-remembered afternoon is familiar.",
    U + "photo-1536759078151-61c8b6f156a8" + Q, "Modern colourful portrait painting"],
  ["The Long Green Quiet", "2024", "Oil & cold wax on canvas", "150 × 105 cm", "6,300",
    "A grass hillside leaning toward the ocean; the green goes on so long it stops being a colour and becomes a feeling.",
    U + "photo-1775026880839-391a076cd3d5" + Q, "Expressive colour field painting of a grassy hillside by the ocean"],
  ["The Argument of Colour", "2022", "Acrylic on canvas", "120 × 90 cm", "4,600",
    "Red, blue and yellow refusing to agree — a small, gorgeous quarrel held permanently in mid-sentence.",
    U + "photo-1605721911519-3dfeb3be25e7" + Q, "Red, blue and yellow abstract painting"],
  ["The Slow Road Home", "2023", "Oil on board", "100 × 80 cm", "3,600",
    "A dirt road, a drift of sheep, the unhurried logic of the countryside at the end of a long day.",
    U + "photo-1578301978693-85fa9c0320b9" + Q, "Pastoral painting of a herd of sheep on a dirt road"],
  ["Close, Then Closer", "2024", "Mixed media on canvas", "100 × 100 cm", "4,500",
    "Painted to be approached — from across the room a mood; from an inch away, entirely made of weather.",
    U + "photo-1667980898743-fcfe470b7d2a" + Q, "Close-up of a modern art canvas with rich textures"],
  ["Portrait at the Blue Hour", "2022", "Oil on canvas", "95 × 75 cm", "3,900",
    "Less a likeness than a mood — the particular blue that exists only for a few minutes after the sun has gone.",
    U + "photo-1599503613556-0f18b122d281" + Q, "Expressive modern portrait in cool blue tones"],
];

const slugify = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Titles that ship with 3 auto-generated detail-crop thumbnails.
const WITH_DETAILS = new Set([
  "Crimson Meridian",
  "Horizon Withheld",
  "Where the Mountains Rest",
  "First Light, Unnamed",
  "Meadow, Breathing",
  "A Thousand Small Hours",
  "The Quiet Lake",
  "Ember Season",
]);

const detailCrops = (url) => {
  if (!url || !url.includes("images.unsplash.com")) return [];
  const base = url.split("?")[0];
  return [
    `${base}?cs=srgb&fm=jpg&q=85&w=900&h=900&fit=crop&crop=focalpoint&fp-x=0.25&fp-y=0.3`,
    `${base}?cs=srgb&fm=jpg&q=85&w=900&h=900&fit=crop&crop=focalpoint&fp-x=0.75&fp-y=0.7`,
    `${base}?cs=srgb&fm=jpg&q=85&w=1400&h=900&fit=crop&crop=edges`,
  ];
};

export const PAINTINGS_FALLBACK = P.map((r, i) => ({
  id: `p${i + 1}`,
  order: i + 1,
  slug: slugify(r[0]),
  title: r[0],
  year: r[1],
  medium: r[2],
  dimensions: r[3],
  currency: "USD",
  price: r[4],
  price_display: `USD ${r[4]}`,
  story: r[5],
  image_url: r[6],
  alt: r[7],
  room_photos: WITH_DETAILS.has(r[0]) ? detailCrops(r[6]) : [],
  status_tag: null,
}));
